import React, { useState } from 'react';
import { API } from '../api/api';
import { startPopupLogin } from '../hooks/useAuthBootstrap';

export default function AuthenticatingModal({ isOpen, devLoginEnabled, popupLoginBlocked }) {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [popupError, setPopupError] = useState('');

  if (!isOpen) return null;

  const handleDevLogin = async (e) => {
    e.preventDefault();
    if (!email.trim() || submitting) return;
    setSubmitting(true);
    setError('');
    try {
      const result = await API.devLogin(email.trim());
      if (result.success) {
        window.location.reload();
      } else {
        setError(result.message || 'Login failed');
        setSubmitting(false);
      }
    } catch (err) {
      setError(err.message || 'Login failed');
      setSubmitting(false);
    }
  };

  // Retried from a click so window.open has a user gesture to spend, which is
  // what the automatic attempt on load lacked.
  const handlePopupLogin = async () => {
    setPopupError('');
    try {
      const opened = await startPopupLogin();
      if (!opened) setPopupError('Your browser is still blocking the sign-in window. Allow popups for this site and try again.');
    } catch (err) {
      setPopupError(err.message || 'Could not start sign-in');
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 z-[200] flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg w-[400px] shadow-xl">
        {devLoginEnabled ? (
          <>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Dev Login</h3>
            <form onSubmit={handleDevLogin}>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="employee@moalemweitemeyer.com"
                autoFocus
                className="w-full border border-gray-300 rounded p-2 mb-3 text-sm"
              />
              {error && <p className="text-sm text-red-600 mb-3">{error}</p>}
              <button
                type="submit"
                disabled={submitting || !email.trim()}
                className="w-full bg-[#ccb778] hover:bg-[#b8a365] disabled:opacity-50 text-white font-semibold py-2 rounded transition-colors"
              >
                {submitting ? 'Logging in…' : 'Log in as employee'}
              </button>
            </form>
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mt-4">
              <p className="text-sm text-gray-700">
                Dev-only bypass for Microsoft SSO — looks the email up in the CRM Employees module.
              </p>
            </div>
          </>
        ) : popupLoginBlocked ? (
          <>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Sign in to continue</h3>
            <p className="text-gray-600 mb-4">
              The calendar is running inside another page, so sign-in has to open in a separate window.
            </p>
            {popupError && <p className="text-sm text-red-600 mb-3">{popupError}</p>}
            <button
              type="button"
              onClick={handlePopupLogin}
              className="w-full bg-[#ccb778] hover:bg-[#b8a365] text-white font-semibold py-2 rounded transition-colors"
            >
              Sign in with Microsoft
            </button>
          </>
        ) : (
          <>
            <div className="flex items-center mb-4">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#ccb778] mr-3"></div>
              <h3 className="text-lg font-semibold text-gray-900">Signing you in...</h3>
            </div>
            <p className="text-gray-600">Redirecting to Microsoft sign-in.</p>
          </>
        )}
      </div>
    </div>
  );
}
